export const filteredViews = {
  filtered_views: "Filtered views",
  add_filtered_view: "Add filtered view",
  add_new_filtered_view: "Add new filtered view",
  create_filtered_view: "Create filtered view",
  edit_filtered_view: "Edit filtered view",
  delete_filtered_view: "Delete filtered view",
  delete_filtered_view_confirmation: "Are you sure you want to delete",
  delete_filtered_view_as: "as a filtered view?",
  delete_filtered_view_warning: "This action cannot be undone.",
  manage_filtered_views: "Manage filtered views",
  manage_filtered_views_description:
    "Filtered views are saved views with applied filters, custom columns, and visible filter controls.",
  default_filters: "Default filters",
  no_saved_views: "No saved views yet. Add one below.",
  view_name: "View name",
  view_name_placeholder: "e.g. Overdue Invoices",
  configure_view_description:
    "Configure this view's applied filters, visible columns, and filter controls.",
  create_view: "Create view",
  save_changes: "Save changes",
  skip: "Skip",
  enter_view_name: "Enter a view name",
  visit_all_tabs: "Visit all tabs first",
  tab_apply_filters: "Apply filters",
  tab_select_columns: "Columns",
  tab_select_document_filters: "Document filters",
  tab_user_access: "User access",
  user_access_title: "Select users with access to this view",
  user_access_description: "Choose which users this view is locked to by default.",
  no_users_available: "No users available",
  select_columns_description: "What columns do you want to see in the table of this view?",
  search_columns: "Search columns",
  add_new_column: "Add new column",
  no_columns_match: "No columns match your search",
  select_document_filters_title: "Select document field filters to view directly",
  select_document_filters_description:
    "What document field filters do you want to use directly in this view.",
  field_name: "Field name",
  add_another_document_field: "Add another document field",
  add_new_column_title: "Add new column",
  search_fields: "Search fields",
  all_fields_added: "All fields already added",
  no_fields_match: "No fields match your search",
  cols: "cols",
  col: "col",
  applied_filters: "applied filters",
  applied_filter: "applied filter",
  visible_filters: "visible filters",
  visible_filter: "visible filter",
  view_created_successfully: "View created successfully",
  view_updated_successfully: "View updated successfully",
  view_deleted_successfully: "View deleted successfully",
  view_saved: "View saved",
  save_in_filtered_view: "Save in filtered view",
  custom_filters: "Custom filters",
  enable_document_custom_view_permission: "Enable the Document Custom View permission to use filtered views.",
  back_to_manage: "Back to manage",
  user_already_locked_to_another_view: "One or more selected users are already locked to another view.",
};
